import type { ISite } from "@similarweb/ui-components";

import { BLOCK_SITE_STATUS } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketingHelper";

export const filterBlockedSites = (sites: ISite[]) => {
    return sites.filter((res) =>
        Array.isArray(res.blockStatus) ? !res.blockStatus.includes(BLOCK_SITE_STATUS) : true,
    );
};
